export const NON_INPUT_FIELDS = ["section", "composedList", "form", "composed"];
export function buildEmptyFormConfig(formKey, label) {
    return {
        type: "form",
        key: formKey,
        label: label,
        fields: [],
        defaultValue: {}
    };
}
export function hasFields(fieldConfig) {
    return fieldConfig.type === "composedList" || fieldConfig.type === "form" || fieldConfig.type === "composed";
}
export function isFieldConfigSection(fieldConfig) {
    return fieldConfig.type === "section";
}
export function isFieldConfigText(fieldConfig) {
    return fieldConfig.type === "text";
}
export function isFieldConfigComposedList(fieldConfig) {
    return fieldConfig.type === "composedList";
}
export function isFieldConfigComposed(fieldConfig) {
    return fieldConfig.type === "composed";
}
export function isFieldConfigOptions(fieldConfig) {
    return fieldConfig.type === "options" || fieldConfig.type === "multipleOptions";
}
